import { Table, Button, Image } from "antd"
import axios from "axios"
import { useState, useEffect, useContext } from "react"
// import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons"
// import { useHistory } from "react-router-dom"
import { UserContext } from "../Context/UserContext"

const TableOrder = () => {
    const [user] = useContext(UserContext)
    const [loading, setLoading] = useState(false)
    const [listOrder, setListOrder] = useState([])
    // let history = useHistory()

    useEffect(()=>{
        const order = async () => {
            setLoading(true)
            const result = await axios.get("https://backend-sportyan.vercel.app/api/all-order", {headers: {"Authorization" : "Bearer "+ user.token}})
                .then((res) => {
                    return res.data
                })
                .catch((err) =>{
                    console.log(err)
                })
                setListOrder(result)
                setLoading(false)
        }
        order()
    }, [user.token])

    let listOrderItem = []
    for ( var i=0; i <= listOrder.length; i++){
        listOrder[i]?.order_item?.map(function(item){
            return listOrderItem.push(item)
        })
    }

    console.log(listOrderItem)
    const columns = [
        {
            title: "No",
            key: "no",
            render: (text) => {
                let index = listOrderItem.indexOf(text)
                return (
                    <>{index+1}</>
                )
            }
        },
        {
            title: "Image",
            dataIndex: "product",
            key: "image",
            render: (record) => {
                return (
                    <Image width={50} height={50}  src={record.image} preview={false}/>
                )
                
            },
        },
        {
            title: "Name",
            dataIndex: "product",
            key: "name",
            sorter: (a,b) => {
                if ( a.product.name< b.product.name){
                    return -1;
                }
                if ( a.product.name> b.product.name){
                    return 1;
                }
                return 0;
            },
            render: (record) =>{
                return(
                    record.name
                )
                
            }
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            sorter: (a,b) => {
                if ( a.quantity< b.quantity){
                    return -1;
                }
                if ( a.quantity> b.quantity){
                    return 1;
                }
              return 0;
            }
        },
        {
            title: "Date Order",
            dataIndex: "createdAt",
            key: "createdAt",
            sorter: (a,b) => {
                if ( a.createdAt < b.createdAt ){
                    return -1;
                }
                if ( a.createdAt > b.createdAt ){
                    return 1;
                }
              return 0;
            },
            render: (record) =>{
                return (
                    record.split('T')[0]
                )
                
            }
        },
        {
            title: "Time Order",
            dataIndex: "createdAt",
            key: "createdAt",
            sorter: (a,b) => {
                if ( a.createdAt < b.createdAt ){
                    return -1;
                }
                if ( a.createdAt > b.createdAt ){
                    return 1;
                }
              return 0;
            },
            render: (record) =>{
                return (
                    record.substr(11).split('.')[0]
                )
                
            }
        },
        {
            title: "Price",
            render: (record) =>{
                return(
                    <p style={{textAlign: "right"}}>{record.quantity*record.product.price}</p>
                )
            }
        },
        {
            title: "Status",
            render: (text) => {
                let index = listOrderItem.indexOf(text)
                return(
                    <p style={listOrder[index].status === "sold"?{fontWeight: "bold", color:"green"}:{fontWeight: "bold", color:"orange"}}>{listOrder[index].status}</p>
                )
            }
        }
    ]

    const HandleChange = (sorter) => {
       console.log(sorter)
    }

    const clearFilters = () => {
        window.location.reload();
    };

    return(
        <>
        <h1>Product</h1>
        <Button type="primary" size="large" style={{marginBottom: "20px", marginRight:"10px" , float: "right"}} onClick={clearFilters}> Reset All Filter</Button>
        <br/>
        <Table loading={loading} columns={columns} dataSource={listOrderItem} onChange={HandleChange}/>
        </>
    )
}

export default TableOrder